import apiService from './apiService';

export const fetchFrtlData = async () => {
  try {
    const response = await apiService.fetchInstance('new/frtl/');
    return response?.data;
  } catch (error) {
    console.error('Error fetching FRTL data:', error);
    return null;
  }
};
